import React from "react";
import { Link } from "react-router-dom";
import { Home, AlertCircle } from "lucide-react";

export default function NotFound() {
  return (
    <div className="min-h-screen bg-white flex items-center justify-center px-4">
      <div className="text-center max-w-[520px]">
        <span
          className="inline-flex items-center justify-center w-20 h-20 rounded-2xl mb-6"
          style={{ background: "rgba(27,110,243,0.1)", color: "#1b6ef3" }}
        >
          <AlertCircle size={40} />
        </span>
        <h1 className="text-7xl font-extrabold mb-3" style={{ color: "#141b34" }}>
          404
        </h1>
        <h2 className="text-2xl font-bold mb-3" style={{ color: "#141b34" }}>
          Seite nicht gefunden
        </h2>
        <p className="text-slate-500 mb-8">
          Die gesuchte Seite existiert nicht oder wurde verschoben.
        </p>
        <Link to="/" className="btn-theme">
          <Home size={18} /> Zur Startseite
        </Link>
      </div>
    </div>
  );
}
